export default "__VITE_ASSET__076d3f1f__"